import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export type UseRefereeListQueryParams = Parameters<typeof SSF.api.judgesList>[0];

export const keys = createQueryKeySet<UseRefereeListQueryParams>('referees');

export function useRefereeListQuery(params: UseRefereeListQueryParams = {}, enabled = true) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.judgesList(params);
      return data;
    },
    queryKey: keys.list(params),
    enabled,
  });
}

export function useRefereeQuery(refereeId: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.judgesRetrieve(refereeId);
      return data;
    },
    queryKey: keys.detail(refereeId),
  });
}
